import React, { ReactNode } from "react"
import styled from "styled-components"
import { Row } from "ui/components/atoms/_atoms"
import { BaseStyles } from "ui/types/base-styles"

const Tags = ({
  children,
  ...rest
}: BaseStyles & {
  children: ReactNode | ReactNode[]
}) => {
  return <Wrapper {...rest}>{children}</Wrapper>
}

export default Tags

export const Wrapper = styled(Row)`
  flex-wrap: wrap;
  grid-gap: ${({ theme }) => theme.space.XS};
`
